import { render } from "./VenueMenu.vue?vue&type=template&id=6444a8cd&scoped=true"
import script from "./VenueMenu.vue?vue&type=script&lang=js"
export * from "./VenueMenu.vue?vue&type=script&lang=js"

import "../_css/sidebarmenu.scss?vue&type=style&index=0&id=6444a8cd&lang=scss&scoped=true&external"
import "./VenueMenu.vue?vue&type=style&index=1&id=6444a8cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6444a8cd"]])

export default __exports__